import DeliveryMode from '../models/DeliveryMode';

import type DeliveryModeWithLabel from '../models/DeliveryModeWithLabel';

const DELIVERY_MODES = Object.values(DeliveryMode);

export const DELIVERY_MODES_WITH_LABEL: DeliveryModeWithLabel[] = [
    {
        label: 'Futárszolgálat',
        value: DeliveryMode.COURIER_SERVICE,
    },
    {
        label: 'Személyes átadás',
        value: DeliveryMode.PICKUP_POINT,
    },
    {
        label: 'Szerelvénybolt tranzit',
        value: DeliveryMode.TRANSIT,
    },
];

export default DELIVERY_MODES;
